export const getDaysLeft = (date: string) => {
  const timeLeft = new Date(date).getTime() - Date.now();
  const daysLeft = timeLeft / (1000 * 60 * 60 * 24);

  return daysLeft > 0 ? Math.ceil(daysLeft) : Math.floor(daysLeft);
};
